import {
	User,
	WellKnownRoles,
	hasAnyRole,
	hasRole,
	hasPermission,
	hasAnyPermission,
} from "@/models/User";
import { ApolloClient } from "apollo-boost";
import gql from "graphql-tag";

const GetSalesRepIdForUser = gql`
	query GetSalesRepIdForUser($userId: Int!) {
		salesReps(where: { userId: { eq: $userId } }) {
			items {
				salesRepId
			}
		}
	}
`;

class UserService {
	private _apollo: ApolloClient<any>;

	constructor(apollo: ApolloClient<any>) {
		this._apollo = apollo;
	}

	async getSalesRepIdForUser(userId: Number): Promise<Number | null> {
		const res = await this._apollo.query({
			query: GetSalesRepIdForUser,
			variables: { userId },
		});

		return res.data.salesReps.items[0]?.salesRepId;
	}

	hasAnyRole(user: User, roles: string[]): boolean {
		return hasAnyRole(user, roles);
	}

	hasRole(user: User, role: string): boolean {
		return hasRole(user, role);
	}

	isAdmin(user: User): boolean {
		return hasAnyRole(user, [WellKnownRoles.ADMIN, WellKnownRoles.SUPER_ADMIN]);
	}

	hasPermission(user: User, permission: string): boolean {
		return hasPermission(user, permission);
	}

	hasAnyPermission(user: User, permissions: string[]): boolean {
		return hasAnyPermission(user, permissions);
	}
}

export default UserService;
